module.exports = __webpack_public_path__ + "836a9ef470f33e5b9c3953fb926849c4.png";